import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import addDesign from './addDesign';
import selectEstimate from './selectEstimate';
import loading from './loading';
import loaded from './loaded';
import clearStore from './clearStore';
import globalError from './globalError';
import globalErrorDismissed from './globalErrorDismissed';
import addContainer from './addContainer';
import addItem from './addItem';
import estimateLoaded from './estimateLoaded';
import closeEstimate from './closeEstimate';
import containerDeleted from './containerDeleted';
import resetContainerCount from './resetContainerCount';
import { requestSuccessToast, dismissSuccessToast } from './requestSuccessToast';
import estimateCopied from './estimateCopied';
import containerCopied from './containerCopied';
import itemCopied from './itemCopied';
import toggleExpandItem from './toggleExpandItem';
import expandAllItems from './expandAllItems';
import collapseAllItems from './collapseAllItems';
import shareModal from './shareModal';
import shareModalDismissed from './shareModalDismissed';
import saveProductDesignAlert from './saveProductDesignAlert';
import saveProductDesignAlertDismiss from './saveProductDesignAlertDismiss';
import controlNewDesignModal from './controlNewDesignModal';
import controlWindowsWithInvalidConfigurationsModal from './controlWindowsWithInvalidConfigurationsModal';

const actions = {
  [types.ADD_ESTIMATE]: addDesign,
  [types.SELECT_ESTIMATE]: selectEstimate,
  [types.LOADING]: loading,
  [types.LOADED]: loaded,
  [types.CLEAR_STORE]: clearStore,
  [types.GLOBAL_ERROR]: globalError,
  [types.GLOBAL_ERROR_DISMISSED]: globalErrorDismissed,
  [types.ADD_CONTAINER]: addContainer,
  [types.ADD_ITEM]: addItem,
  [types.ESTIMATE_LOADED]: estimateLoaded,
  [types.CLOSE_ESTIMATE]: closeEstimate,
  [types.CONTAINER_DELETED]: containerDeleted,
  [types.RESET_CONTAINER_COUNT]: resetContainerCount,
  [types.SUCCESS_TOAST_REQUESTED]: requestSuccessToast,
  [types.SUCCESS_TOAST_DISMISSED]: dismissSuccessToast,
  [types.ESTIMATE_COPIED]: estimateCopied,
  [types.CONTAINER_COPIED]: containerCopied,
  [types.ITEM_COPIED]: itemCopied,
  [types.uiState.TOGGLE_EXPAND_ITEM]: toggleExpandItem,
  [types.uiState.EXPAND_ALL]: expandAllItems,
  [types.uiState.COLLAPSE_ALL]: collapseAllItems,
  [types.share.SHARE_MODAL]: shareModal,
  [types.share.SHARE_MODAL_DISMISSED]: shareModalDismissed,
  [types.uiState.SAVE_PRODUCT_DESIGN_ALERT]: saveProductDesignAlert,
  [types.uiState.SAVE_PRODUCT_DESIGN_ALERT_DISMISS]: saveProductDesignAlertDismiss,
  [types.uiState.CONTROL_NEW_DESIGN_MODAL]: controlNewDesignModal,
  [types.uiState.CONTROL_WINDOWS_WITH_INVALID_CONFIGURATIONS_MODAL]:
  controlWindowsWithInvalidConfigurationsModal,
};

const initialState = {
  containerCount: {},
  itemCount: {},
  toastOptions: { display: false },
  saveProductDesignAlert: false,
  expandedItems: [],
  shareModalOpen: false,
  newDesignModalOpen: false,
  windowsWithInvalidConfigurationsModalOpen: false,
  windowsWithInvalidConfigurations: [],
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
